var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search",
      on: {
        click: function($event) {
          return _vm.$refs.i.focus()
        }
      }
    },
    [
      _vm._t("before", [_c("i", { staticClass: "icon" })]),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { fake_pass: "", type: "password" }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          { name: "model", rawName: "v-model", value: _vm.v, expression: "v" }
        ],
        ref: "i",
        attrs: {
          readonly: "",
          onfocus: "this.removeAttribute('readonly');",
          placeholder: _vm.placeholder,
          name: "search",
          autocomplete: "off",
          type: "text"
        },
        domProps: { value: _vm.v },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.v = $event.target.value
            },
            function($event) {
              $event.preventDefault()
              return _vm.updateKey($event)
            }
          ]
        }
      }),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { fake_pass: "", type: "password" }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }